export const loadScript = (url: string, id: string, then?: GlobalEventHandlers['onload']) => {
  if (document.getElementById(id)) return;

  const script = document.createElement('script');

  if (then) script.onload = then;

  script.async = true;
  script.src = url;
  script.id = id;

  document.getElementsByTagName('head')[0].appendChild(script);
};
